export default "__VITE_ASSET__FNBpdOlw__"